export const skillTranslationKeys = {
  "1 Password MSP Edition": "PasswordMSPEdition",
  ".NET": "NET",
  "Agile-Waterfall Hybrid": "AgileWaterfallHybrid",
  Angular: "Angular",
  Ansible: "Ansible",
  "Argo CD": "ArgoCD",
  "ArmyG6-CA Cyber Concept": "ArmyG6_CACyberConcept",
  AWS: "AWS",
  "AWS SageMaker": "AWSSageMaker",
  Azure: "Azure",
  "Azure DevOps": "AzureDevOps",
  "Azure Machine Learning": "AzureMachineLearning",
  "Azure Repos": "AzureRepos",
  Bamboo: "Bamboo",
  Bitbucket: "Bitbucket",
  "Burp Suite": "BurpSuite",
  "C#": "CSharp",
  "C++": "Cplusplus",
  "Canadian Cyber Security Tool (CCST)": "CanadianCyberSecurityTool",
  "Chaîne de Montage": "ChaîneDeMontage",
  "Check Point Quantum": "CheckPointQuantum",
  CircleCI: "CircleCI",
  "Cloud Formation": "CloudFormation",
  "Cloud Security": "CloudSecurity",
  Confluence: "Confluence",
  "CNR Virtuel pour Azure (MapleTap)": "CNRVirtuelpourAzure",
  Crystal: "Crystal",
  "Critical Path Method (CPM)": "CriticalPathMethod",
  "CrowdStrike Falcon": "CrowdStrikeFalcon",
  "D365 (Dynamics 365)": "D365",
  "Data Engineering": "DataEngineering",
  "Data Warehousing": "DataWarehousing",
  Databricks: "Databricks",
  Django: "Django",
  Docker: "Docker",
  "Disciplined Agile Delivery (DAD)": "DisciplinedAgileDelivery",
  ETL: "ETL",
  Excel: "Excel",
  "Extreme Programming (XP)": "ExtremeProgramming",
  Flask: "Flask",
  GCP: "GCP",
  GCdocs: "GCdocs",
  "GCpedia / GCconnex / GCcollab": "GCpedia_GCconnex_GCcollab",
  Git: "Git",
  GitHub: "GitHub",
  "GitHub Actions": "GitHubActions",
  "GitHub Projects": "GitHubProjects",
  GitLab: "GitLab",
  "GitLab CI/CD": "GitLab_CI_CD",
  Go: "Go",
  "Google Cloud AI Platform": "GoogleCloudAIPlatform",
  "Hugging Face Transformers": "HuggingFaceTransformers",
  IAM: "IAM",
  "IAM (Identity & Access Management)": "IAM",
  Informatica: "Informatica",
  "IBM Watson": "IBMWatson",
  Java: "Java",
  JavaScript: "JavaScript",
  Jenkins: "Jenkins",
  Jira: "Jira",
  "Jupyter Notebooks": "JupyterNotebooks",
  Kanban: "Kanban",
  Keras: "Keras",
  Kubernetes: "Kubernetes",
  Lean: "Lean",
  "Lean Six Sigma": "LeanSixSigma",
  "LeSS (Large Scale Scrum)": "LeSS",
  LightGBM: "LightGBM",
  Looker: "Looker",
  "M365 (Microsoft 365)": "M365",
  Mercurial: "Mercurial",
  Metasploit: "Metasploit",
  "Microsoft Copilot": "MicrosoftCopilot",
  "Microsoft Teams": "MicrosoftTeams",
  MLflow: "MLflow",
  "MS Project": "MSProject",
  Nexus: "Nexus",
  "Nexus Repository": "NexusRepository",
  "Node.js": "Nodejs",
  "NoSQL (MongoDB, etc.)": "NoSQL",
  OpenShift: "OpenShift",
  Oracle: "Oracle",
  Other: "Other",
  "Penetration Testing": "PenetrationTesting",
  Peoplesoft: "Peoplesoft",
  "Perforce (Helix Core)": "Perforce",
  Pipelines: "Pipelines",
  "PMBOK (Project Management Body of Knowledge)": "PMBOK",
  "Pont d'Observation": "PontDObservation",
  "Power BI": "Power_BI",
  PowerBI: "PowerBI",
  "Power Query": "PowerQuery",
  PRINCE2: "PRINCE2",
  "PRINCE2 Agile": "PRINCE2Agile",
  Pulumi: "Pulumi",
  Python: "Python",
  PyTorch: "PyTorch",
  R: "R",
  "Rational ClearCase": "RationalClearCase",
  React: "React",
  SAFe: "SAFe",
  "SAFe (Scaled Agile Framework)": "SAFe",
  SAP: "SAP",
  Salesforce: "Salesforce",
  "Scikit-learn": "ScikitLearn",
  Scrum: "Scrum",
  ServiceNow: "ServiceNow",
  SharePoint: "SharePoint",
  SIEM: "SIEM",
  SixSigma: "SixSigma",
  Snowflake: "Snowflake",
  "SOC (Security Operations Center)": "SOC",
  SonarQube: "SonarQube",
  Splunk: "Splunk",
  "Spotify Model": "SpotifyModel",
  "Spring Boot": "SpringBoot",
  SQL: "SQL",
  "SQL (PostgreSQL, MySQL, etc.)": "SQL_PostgreSQL",
  "SSIS / SSRS": "SSIS",
  Spinnaker: "Spinnaker",
  Tableau: "Tableau",
  Teams: "Teams",
  Terraform: "Terraform",
  TensorFlow: "TensorFlow",
  "Target Security Operating Model (TSOM)": "TargetSecurityOperatingModel",
  Trello: "Trello",
  "Travis CI": "TravisCI",
  TypeScript: "TypeScript",
  Waterfall: "Waterfall",
  Wireshark: "Wireshark",
  XGBoost: "XGBoost",
  "Zero Trust Architecture": "ZeroTrustArchitecture",
  "Dynamic Systems Development Method (DSDM)": "DynamicSystemsDevelopmentMethod",
  "Integrated Project Delivery (IPD)": "IntegratedProjectDelivery",
  "Program Evaluation and Review Technique (PERT)": "ProgramEvaluationAndReviewTechnique",
} as const;

export const translations = {
  en: {
    CSharp: "C#",
    Cplusplus: "C++",
    Go: "Go",
    Java: "Java",
    JavaScript: "JavaScript",
    Python: "Python",
    R: "R",
    SQL: "SQL",
    TypeScript: "TypeScript",
    Other: "Other",
    NET: ".NET",
    Angular: "Angular",
    Nodejs: "Node.js",
    PyTorch: "PyTorch",
    React: "React",
    ScikitLearn: "Scikit-learn",
    SpringBoot: "Spring Boot",
    TensorFlow: "TensorFlow",
    Ansible: "Ansible",
    AWS: "AWS",
    Azure: "Azure",
    CloudFormation: "Cloud Formation",
    Docker: "Docker",
    GCP: "GCP",
    Kubernetes: "Kubernetes",
    Terraform: "Terraform",
    DataEngineering: "Data Engineering",
    DataWarehousing: "Data Warehousing",
    Databricks: "Databricks",
    ETL: "ETL",
    Excel: "Excel",
    Looker: "Looker",
    Pipelines: "Pipelines",
    PowerQuery: "Power Query",
    Power_BI: "Power BI",
    Snowflake: "Snowflake",
    SSIS: "SSIS / SSRS",
    Tableau: "Tableau",
    AWSSageMaker: "AWS SageMaker",
    AzureMachineLearning: "Azure Machine Learning",
    Django: "Django",
    Flask: "Flask",
    GoogleCloudAIPlatform: "Google Cloud AI Platform",
    HuggingFaceTransformers: "Hugging Face Transformers",
    IBMWatson: "IBM Watson",
    JupyterNotebooks: "Jupyter Notebooks",
    Keras: "Keras",
    LightGBM: "LightGBM",
    MicrosoftCopilot: "Microsoft Copilot",
    MLflow: "MLflow",
    NoSQL: "NoSQL (MongoDB, etc.)",
    PowerBI: "PowerBI",
    SQL_PostgreSQL: "SQL (PostgreSQL, MySQL, etc.)",
    XGBoost: "XGBoost",
    PasswordMSPEdition: "Password MSP Edition",
    ArmyG6_CACyberConcept: "ArmyG6-CA Cyber Concept",
    BurpSuite: "Burp Suite",
    CanadianCyberSecurityTool: "Canadian Cyber Security Tool (CCST)",
    "ChaîneDeMontage": "Chaîne de Montage",
    CheckPointQuantum: "Check Point Quantum",
    CloudSecurity: "Cloud Security",
    CNRVirtuelpourAzure: "CNR Virtuel pour Azure (MapleTap)",
    CrowdStrikeFalcon: "CrowdStrike Falcon",
    IAM: "IAM (Identity & Access Management)",
    Metasploit: "Metasploit",
    PenetrationTesting: "Penetration Testing",
    PontDObservation: "Pont d'Observation",
    SIEM: "SIEM",
    SOC: "SOC (Security Operations Center)",
    Splunk: "Splunk",
    TargetSecurityOperatingModel: "Target Security Operating Model (TSOM)",
    Wireshark: "Wireshark",
    ZeroTrustArchitecture: "Zero Trust Architecture",
    ArgoCD: "Argo CD",
    AzureDevOps: "Azure DevOps",
    Bamboo: "Bamboo",
    CircleCI: "CircleCI",
    GitHubActions: "GitHub Actions",
    GitLab_CI_CD: "GitLab CI/CD",
    Jenkins: "Jenkins",
    NexusRepository: "Nexus Repository",
    OpenShift: "OpenShift",
    Pulumi: "Pulumi",
    SonarQube: "SonarQube",
    Spinnaker: "Spinnaker",
    TravisCI: "Travis CI",
    AzureRepos: "Azure Repos",
    Bitbucket: "Bitbucket",
    Git: "Git",
    GitHub: "GitHub",
    GitLab: "GitLab",
    Mercurial: "Mercurial",
    Perforce: "Perforce (Helix Core)",
    RationalClearCase: "Rational ClearCase",
    Informatica: "Informatica",
    M365: "M365 (Microsoft 365)",
    Oracle: "Oracle",
    Peoplesoft: "Peoplesoft",
    Salesforce: "Salesforce",
    SAP: "SAP",
    ServiceNow: "ServiceNow",
    SharePoint: "SharePoint",
    Teams: "Teams",
    Confluence: "Confluence",
    D365: "D365 (Dynamics 365)",
    GCdocs: "GCdocs",
    GCpedia_GCconnex_GCcollab: "GCpedia / GCconnex / GCcollab",
    GitHubProjects: "GitHub Projects",
    Jira: "Jira",
    MicrosoftTeams: "Microsoft Teams",
    MSProject: "MS Project",
    Trello: "Trello",
    AgileWaterfallHybrid: "Agile-Waterfall Hybrid",
    CriticalPathMethod: "Critical Path Method (CPM)",
    Crystal: "Crystal",
    DisciplinedAgileDelivery: "Disciplined Agile Delivery (DAD)",
    DynamicSystemsDevelopmentMethod: "Dynamic Systems Development Method (DSDM)",
    ExtremeProgramming: "Extreme Programming (XP)",
    IntegratedProjectDelivery: "Integrated Project Delivery (IPD)",
    Kanban: "Kanban",
    Lean: "Lean",
    LeanSixSigma: "Lean Six Sigma",
    LeSS: "LeSS (Large Scale Scrum)",
    Nexus: "Nexus",
    PMBOK: "PMBOK (Project Management Body of Knowledge)",
    PRINCE2: "PRINCE2",
    PRINCE2Agile: "PRINCE2 Agile",
    ProgramEvaluationAndReviewTechnique: "Program Evaluation and Review Technique (PERT)",
    SAFe: "SAFe (Scaled Agile Framework)",
    Scrum: "Scrum",
    SixSigma: "SixSigma",
    SpotifyModel: "Spotify Model",
    Waterfall: "Waterfall",
  },
  fr: {
    CSharp: "C#",
    Cplusplus: "C++",
    Go: "Go",
    Java: "Java",
    JavaScript: "JavaScript",
    Python: "Python",
    R: "R",
    SQL: "SQL",
    TypeScript: "TypeScript",
    Other: "Autre",
    NET: ".NET",
    Angular: "Angular",
    Nodejs: "Node.js",
    PyTorch: "PyTorch",
    React: "React",
    ScikitLearn: "Scikit-learn",
    SpringBoot: "Spring Boot",
    TensorFlow: "TensorFlow",
    Ansible: "Ansible",
    AWS: "AWS",
    Azure: "Azure",
    CloudFormation: "Formation Cloud",
    Docker: "Docker",
    GCP: "GCP",
    Kubernetes: "Kubernetes",
    Terraform: "Terraform",
    DataEngineering: "Ingénierie des données",
    DataWarehousing: "Entreposage de données",
    Databricks: "Databricks",
    ETL: "ETL",
    Excel: "Excel",
    Looker: "Looker",
    Pipelines: "Pipelines",
    PowerQuery: "Power Query",
    Power_BI: "Power BI",
    Snowflake: "Snowflake",
    SSIS: "SSIS / SSRS",
    Tableau: "Tableau",
    AWSSageMaker: "AWS SageMaker",
    AzureMachineLearning: "Apprentissage automatique Azure",
    Django: "Django",
    Flask: "Flask",
    GoogleCloudAIPlatform: "Plateforme d'IA Google Cloud",
    HuggingFaceTransformers: "Hugging Face Transformers",
    IBMWatson: "IBM Watson",
    JupyterNotebooks: "Jupyter Notebooks",
    Keras: "Keras",
    LightGBM: "LightGBM",
    MicrosoftCopilot: "Microsoft Copilot",
    MLflow: "MLflow",
    NoSQL: "NoSQL (MongoDB, etc.)",
    PowerBI: "PowerBI",
    SQL_PostgreSQL: "SQL (PostgreSQL, MySQL, etc.)",
    XGBoost: "XGBoost",
    PasswordMSPEdition: "Password Édition MSP",
    ArmyG6_CACyberConcept: "Concept cybernétique ArmyG6-CA",
    BurpSuite: "Burp Suite",
    CanadianCyberSecurityTool: "Outil de cybersécurité canadien (CCST)",
    "ChaîneDeMontage": "Chaîne de Montage",
    CheckPointQuantum: "Check Point Quantum",
    CloudSecurity: "Sécurité infonuagique",
    CNRVirtuelpourAzure: "CNR Virtuel pour Azure (MapleTap)",
    CrowdStrikeFalcon: "CrowdStrike Falcon",
    IAM: "IAM (gestion des identités et des accès)",
    Metasploit: "Metasploit",
    PenetrationTesting: "Tests de pénétration",
    PontDObservation: "Pont d'Observation",
    SIEM: "SIEM",
    SOC: "Centre des opérations de sécurité (COS)",
    Splunk: "Splunk",
    TargetSecurityOperatingModel: "Modèle opérationnel cible de sécurité (TSOM)",
    Wireshark: "Wireshark",
    ZeroTrustArchitecture: "Architecture à confiance zéro",
    ArgoCD: "Argo CD",
    AzureDevOps: "Azure DevOps",
    Bamboo: "Bamboo",
    CircleCI: "CircleCI",
    GitHubActions: "GitHub Actions",
    GitLab_CI_CD: "GitLab CI/CD",
    Jenkins: "Jenkins",
    NexusRepository: "Nexus Repository",
    OpenShift: "OpenShift",
    Pulumi: "Pulumi",
    SonarQube: "SonarQube",
    Spinnaker: "Spinnaker",
    TravisCI: "Travis CI",
    AzureRepos: "Azure Repos",
    Bitbucket: "Bitbucket",
    Git: "Git",
    GitHub: "GitHub",
    GitLab: "GitLab",
    Mercurial: "Mercurial",
    Perforce: "Perforce (Helix Core)",
    RationalClearCase: "Rational ClearCase",
    Informatica: "Informatica",
    M365: "M365 (Microsoft 365)",
    Oracle: "Oracle",
    Peoplesoft: "Peoplesoft",
    Salesforce: "Salesforce",
    SAP: "SAP",
    ServiceNow: "ServiceNow",
    SharePoint: "SharePoint",
    Teams: "Teams",
    Confluence: "Confluence",
    D365: "D365 (Dynamics 365)",
    GCdocs: "GCdocs",
    GCpedia_GCconnex_GCcollab: "GCpedia / GCconnex / GCcollab",
    GitHubProjects: "Projets GitHub",
    Jira: "Jira",
    MicrosoftTeams: "Microsoft Teams",
    MSProject: "MS Project",
    Trello: "Trello",
    AgileWaterfallHybrid: "Approche hybride agile-cascade",
    CriticalPathMethod: "Méthode du chemin critique (MPC)",
    Crystal: "Crystal",
    DisciplinedAgileDelivery: "Livraison agile disciplinée (DAD)",
    DynamicSystemsDevelopmentMethod: "Méthode de développement de systèmes dynamiques (DSDM)",
    ExtremeProgramming: "Programmation extrême (XP)",
    IntegratedProjectDelivery: "Livraison de projet intégrée (LPI)",
    Kanban: "Kanban",
    Lean: "Lean",
    LeanSixSigma: "Lean Six Sigma",
    LeSS: "LeSS (Large Scale Scrum)",
    Nexus: "Nexus",
    PMBOK: "PMBOK (Project Management Body of Knowledge)",
    PRINCE2: "PRINCE2",
    PRINCE2Agile: "PRINCE2 Agile",
    ProgramEvaluationAndReviewTechnique: "Technique d'évaluation et de révision des programmes (PERT)",
    SAFe: "SAFe (Scaled Agile Framework)",
    Scrum: "Scrum",
    SixSigma: "SixSigma",
    SpotifyModel: "Modèle Spotify",
    Waterfall: "Cascade",
  },
};
